import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { Button, EmptyState, Page } from '@/ds';
import { isApiError, reasonOf } from '@/lib/api/errors';
import { NoAccess } from './NoAccess';

/** A page that couldn't load. Says what failed and that nothing changed, and offers a retry. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  if (isApiError(error) && error.status === 403) return <NoAccess />;
  const notFound = isApiError(error) && error.status === 404;

  return (
    <Page narrow>
      <div className="rq-panel">
        <EmptyState
          kind="error"
          title={notFound ? "This record doesn't exist" : "Couldn't load this page"}
          action={
            notFound ? (
              <Button size="sm" href="/">
                Go to your start page
              </Button>
            ) : (
              <Button
                size="sm"
                icon="refresh-cw"
                onClick={() => {
                  reset();
                  void router.invalidate();
                }}
              >
                Try again
              </Button>
            )
          }
        >
          {notFound ? null : (
            <>
              Nothing was changed.
              {reasonOf(error) ? <> Reason given: {reasonOf(error)}</> : null}
            </>
          )}
        </EmptyState>
      </div>
    </Page>
  );
}
